import React from "react";

function Field({ label, value }) {
    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>
            <input
                className="form-control"
                readOnly
                value={value || "-"}
                style={{
                    backgroundColor: "#f8f9fa",
                    color: "#000",
                    fontWeight: "600",
                    borderColor: "#ced4da",
                }}
            />
        </div>
    );
}

export default function ViewModelVendor({
    showViewModal,
    viewData,
    closeViewModal,
}) {
    if (!showViewModal || !viewData) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.5)",
                zIndex: 999,
            }}
        >
            <div
                style={{
                    position: "fixed",
                    bottom: "-40%",
                    top: "55%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "750px",
                    background: "#fff",
                    borderRadius: "10px",
                    zIndex: 1000,
                    maxHeight: "90vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                        padding: "16px 20px",
                        borderBottom: "1px solid #ddd",
                    }}
                >
                    <h5 className="mb-0">Vendor Details</h5>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={closeViewModal}
                    >
                        <i className="ti ti-x"></i>
                    </button>
                </div>

                <div style={{ padding: "20px", overflowY: "auto" }}>
                    <div className="row">
                        <div className="col-md-6">
                            <Field label="Vendor Name" value={viewData.vendorName} />
                            <Field label="First Name" value={viewData.firstName} />
                            <Field label="Email" value={viewData.emailId} />
                            <Field label="Phone" value={viewData.phone} />
                            <Field label="Address" value={viewData.address} />
                            <Field label="Country" value={viewData.country} />
                            <Field label="District" value={viewData.city} />
                            <Field label="PAN" value={viewData.PAN} />
                            <Field label="GSTN" value={viewData.GSTN} />
                            <Field label="ZIP" value={viewData.zip} />
                            <Field label="Status" value={viewData.status} />
                            <Field
                                label="Created By"
                                value={
                                    viewData.createdByName
                                        ? `${viewData.createdByName}${viewData.createdByCode ? ` - ${viewData.createdByCode}` : ""}`
                                        : "-"
                                }
                            />
                        </div>

                        <div className="col-md-6">
                            <Field label="Vendor Code" value={viewData.vendorCode} />
                            <Field label="Last Name" value={viewData.lastName} />
                            <Field label="Mobile No" value={viewData.mobileNo} />
                            <Field label="Website" value={viewData.website} />
                            <Field label="Landmark" value={viewData.landMark} />
                            <Field label="State" value={viewData.state} />
                            <Field label="Vendor Category" value={viewData.vendorCategoryName} />
                            <Field label="Fax" value={viewData.fax} />
                            <Field label="TAN" value={viewData.TAN} />
                            <Field label="CIN" value={viewData.CIN} />
                            <Field label="Trademark No" value={viewData.trademarkNo} />
                            <Field
                                label="Updated By"
                                value={
                                    viewData.updatedByName
                                        ? `${viewData.updatedByName}${viewData.updatedByCode ? ` - ${viewData.updatedByCode}` : ""}`
                                        : "-"
                                }
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-2">
                        <button className="btn btn-secondary" onClick={closeViewModal}>
                            <i className="ti ti-cancel me-1"></i> Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
